module.exports = __webpack_public_path__ + "img/author.00231e99.png";